'use client'

import dynamic from 'next/dynamic'

/** Client-only chunk: building-blocks calculator uses styled-components; load after hydration. */
export default dynamic(() => import('./productCalculator'), { ssr: false })
